import { redirect, type LoaderFunction } from 'react-router';
import { env } from '@/env';
import { UI_TEXT } from '@/shared/languages';
import { encodeResultState } from '@/shared/lib';
import { ROUTES } from '@/shared/routing';

/**
 * 결제 비활성 게이트 — env `tossPaymentEnabled` 가 `false` 면 구독 화면 진입을 **채널톡 문의 안내**로 돌린다
 * (`/subscriptions/result` 의 `pending` — contact_support 이미지 + 채널톡 문의 + 뒤로가기 버튼셋).
 *
 * **라우트에서 막는 이유**: 버튼만 가리면 URL 직접 입력으로 뚫린다. 부모 loader 에 걸어 목록·구독유형·콜백까지
 * 모든 구독 경로를 한 번에 닫는다.
 *
 * ⚠️ **안내 화면 자신은 예외** — 결과 페이지도 `/subscriptions` 의 자식이라 부모 loader 를 함께 타므로,
 * 예외를 두지 않으면 리다이렉트가 자기 자신을 다시 불러 무한 루프가 된다.
 */
export const tossPaymentGuard: LoaderFunction = ({ request }) => {
  if (env.tossPaymentEnabled) return null;
  const { pathname } = new URL(request.url);
  if (pathname === ROUTES.SUBSCRIPTIONS_RESULT) return null;

  const state = encodeResultState({
    status: 'pending', // 실패가 아니라 "안내" — 버튼셋(채널톡 문의 + 뒤로가기)은 failed 와 공통.
    title: UI_TEXT.RESULT_PAYMENT_CLOSED_TITLE,
    subTitle: UI_TEXT.RESULT_PAYMENT_CLOSED_SUBTITLE,
    // redirectUrl 은 싣지 않는다 — 되돌아갈 곳이 다시 막힌 구독 화면이라 안내→구독→안내 왕복이 된다.
    // 뒤로가기 버튼도 숨긴다 — 홈 폴백으로 흘러가면 사용자가 요청하지도 않은 화면으로 밀려난다.
    hideBack: true,
  });
  return redirect(`${ROUTES.SUBSCRIPTIONS_RESULT}?state=${state}`);
};
